<ng-content select="caption"/>
<ng-content select="colgroup, col"/>
<ng-container headerRowOutlet/>
<ng-container rowOutlet/>
<ng-container noDataRowOutlet/>
<ng-container footerRowOutlet/>
<tbody class="iss-tbody-loading" *ngIf="loading">
  <tr *ngFor="let _ of loadingRows">
    <td class="iss-loading-cell" colspan="999">&nbsp;</td>
  </tr>
</tbody>
